import { render, staticRenderFns } from "./GastroVisitaProctologicaEdit.vue?vue&type=template&id=3478c85e"
import script from "./GastroVisitaProctologicaEdit.vue?vue&type=script&lang=js"
export * from "./GastroVisitaProctologicaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports